<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "InformasiWaGroup",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
